import Format from 'app/src/data/Format';
import RetailModel from 'app/src/data/models/RetailModel';
import URLHelper from 'app/src/data/models/utils/URLHelper';

export default class Gateway extends RetailModel {
  get defaults() {
    return {};
  }

  /**
   * Return the url for the Gateway endpoint
   */
  url() {
    return URLHelper.getAccountURL('/Gateway.json');
  }

  /**
   * Overridden to parse out the superfluous json that the LSCloud returns us
   * @param response - the json object returned from the fetch call before this object has initialized from it
   * @returns {*} the json object that this object will initialize itself from
   */
  parse(response) {
    // trim out wonky stuff from the response which is present if we fetch a single model
    // but not if it's coming from a collection
    let gateway = super.parse(response);

    // the Cloud API has a tendency to send all values as strings so let's make sure they're of the proper type
    gateway.gatewayID = Format.parseInt(gateway.gatewayID);

    return gateway;
  }
}
